import styled from "styled-components";

export const WrapperCardCashbackReport = styled.div`
  width: 100%;
  height: 100%;
  background: #f0f2f5;
  min-height: calc(100vh - 64px);
`;
